import { render, staticRenderFns } from "./wxShare.vue?vue&type=template&id=14007faf&scoped=true&"
import script from "./wxShare.vue?vue&type=script&lang=js&"
export * from "./wxShare.vue?vue&type=script&lang=js&"
import style0 from "./wxShare.vue?vue&type=style&index=0&id=14007faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14007faf",
  null
  
)

export default component.exports